<template>
  <div class="wrap">
    <hr color="B3C3EC">
    <div class="content">
      您当前还未拥有虚拟形象，请自由选择喜欢的部件组合，首次生成<span style="color:red">免费</span>。<br/>
      如有修改的需要，进入游戏后可以在各个城市的<span style="color:red">美容中心</span>进行更改。<br/>
    </div>
    <div class="beauty-content" v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      element-loading-text="加载中" element-loading-spinner="el-icon-loading">
      <div class="preview-section">
        <div class="preview-row">
          <div class="preview-col">
            <div class="preview-label">我的形象</div>
            <div class="preview-box">
              <div class="preview-inner" v-if="selectedHeader.faceUrl">
                <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.faceUrl + ')' }"></div>
                <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.eyeUrl + ')' }"></div>
                <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.mouthUrl + ')' }"></div>
                <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.hairUrl + ')' }"></div>
              </div>
              <div class="preview-inner" v-else>
                <div class="no-header">暂无</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="selector-section" v-if="headerTypes.face.length > 0">
        <div class="type-group" v-for="(group, typeKey) in headerTypes" :key="typeKey">
          <div class="type-label">{{ typeLabels[typeKey] }}</div>
          <div class="type-items">
            <div v-for="item in group" :key="item.facialId"
              class="type-item"
              :class="{ active: isSelected(typeKey, item.facialId) }"
              @click="selectType(typeKey, item)">
              <img :src="ossPath + item.picUrl" :title="item.facialId">
            </div>
          </div>
        </div>
      </div>

      <div class="action-section">
        <el-button type="warning" plain size="mini" @click="randomPreview">随机预览</el-button>
        <el-button type="primary" plain size="mini" @click="saveHeader">保存形象</el-button>
      </div>
    </div>
    <hr color="B3C3EC">
  </div>
</template>

<script>
import { getRequest } from '../../utils/api'
import { postRequest } from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'initUserHeader',
  data() {
    return {
      loading: false,
      headerTypeList: [],
      headerTypes: {
        face: [],
        mouth: [],
        eye: [],
        hair: []
      },
      selectedHeader: {
        faceId: '',
        mouthId: '',
        eyeId: '',
        hairId: '',
        faceUrl: '',
        mouthUrl: '',
        eyeUrl: '',
        hairUrl: ''
      },
      typeLabels: {
        face: '脸型',
        eye: '眼睛',
        mouth: '嘴巴',
        hair: '发型'
      },
      facialTypeMap: {
        '01': 'face',
        '02': 'mouth',
        '03': 'hair',
        '04': 'eye'
      }
    }
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getRequest('/user/userHeader/listHeaderType', {}).then(resp => {
        this.loading = false
        if (resp.status == 200) {
          var respData = resp.data
          if (200 == respData.status && null != respData.data) {
            // 后端下发 {list, changeHeaderCost}（六章①），与美容中心同口径
            this.headerTypeList = respData.data.list || respData.data
            this.groupHeaderTypes()
            this.randomPreview()
          }
        }
      }, resp => {
        this.loading = false
        Message.error('获取五官类型异常')
      })
    },
    groupHeaderTypes() {
      var groups = { face: [], mouth: [], eye: [], hair: [] }
      for (var i = 0; i < this.headerTypeList.length; i++) {
        var item = this.headerTypeList[i]
        var key = this.facialTypeMap[item.facialType]
        if (key) {
          groups[key].push(item)
        }
      }
      this.headerTypes = groups
    },
    isSelected(typeKey, facialId) {
      var mapKey = typeKey + 'Id'
      return this.selectedHeader[mapKey] === facialId
    },
    selectType(typeKey, item) {
      this.selectedHeader[typeKey + 'Id'] = item.facialId
      this.selectedHeader[typeKey + 'Url'] = item.picUrl
    },
    randomPreview() {
      var keys = ['face', 'eye', 'mouth', 'hair']
      for (var i = 0; i < keys.length; i++) {
        var group = this.headerTypes[keys[i]]
        if (group.length > 0) {
          var randomIndex = Math.floor(Math.random() * group.length)
          var item = group[randomIndex]
          this.selectedHeader[keys[i] + 'Id'] = item.facialId
          this.selectedHeader[keys[i] + 'Url'] = item.picUrl
        }
      }
    },
    saveHeader() {
      if (!this.selectedHeader.faceId || !this.selectedHeader.mouthId ||
          !this.selectedHeader.eyeId || !this.selectedHeader.hairId) {
        Message.warning('请选择完整的五官')
        return
      }
      var _this = this
      this.$confirm('确认使用当前形象进入幻之大地吗？首次生成<span style="color:red">免费</span>，确认后将无法更改。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
        appendToBody: true,
        zIndex: 3000
      }).then(function () {
        _this.loading = true
        postRequest('/user/userHeader/saveHeader', {
          faceId: _this.selectedHeader.faceId,
          mouthId: _this.selectedHeader.mouthId,
          eyeId: _this.selectedHeader.eyeId,
          hairId: _this.selectedHeader.hairId
        }).then(resp => {
          _this.loading = false
          if (resp.status == 200) {
            var respData = resp.data
            if (200 == respData.status) {
              Message.success('虚拟形象已成功生成，欢迎进入幻之大地。')
              // 建号完成落到街道默认点（南大门）；/main.html 默认子路由是家内景，会误落家中
              _this.$router.replace({path: '/main/street.html'})
            } else {
              Message.error(respData.message)
              _this.$router.replace({path: '/'})
            }
          } else {
            Message.error('用户非法⊙﹏⊙∥!')
            _this.$router.replace({path: '/'})
          }
        }, resp => {
          _this.loading = false
          Message.error('用户非法⊙﹏⊙∥!')
          _this.$router.replace({path: '/'})
        })
      }, function () {
        //取消
      })
    }
  }
}
</script>

<style scoped>
.wrap {
  margin: auto;
  text-align: center;
}
.content {
  line-height: 2em;
}
.beauty-content {
  max-width: 480px;
  margin: 0 auto;
}
.preview-section {
  margin-bottom: 16px;
}
.preview-row {
  display: flex;
  justify-content: center;
}
.preview-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.preview-label {
  font-size: 14px;
  font-weight: bold;
  color: #ff0000;
  margin-bottom: 8px;
}
.preview-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-inner {
  width: 96px;
  height: 120px;
  position: relative;
}
.preview-inner .layer {
  width: 96px;
  height: 120px;
  position: absolute;
  top: 0;
  left: 0;
  background-size: 96px 120px;
  background-repeat: no-repeat;
}
.no-header {
  width: 96px;
  height: 120px;
  line-height: 120px;
  background: #f0f0f0;
  color: #999;
  font-size: 13px;
}
.selector-section {
  text-align: left;
  margin-bottom: 12px;
}
.type-group {
  margin-bottom: 10px;
}
.type-label {
  font-size: 13px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
  padding-left: 4px;
}
.type-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.type-item {
  width: 48px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  background: #fafaf5;
  transition: border-color 0.2s;
}
.type-item:hover {
  border-color: #72b653;
}
.type-item.active {
  border-color: #ff6600;
  background: #fff3e0;
}
.type-item img {
  width: 40px;
  height: 50px;
}
.action-section {
  text-align: center;
  margin-top: 12px;
  margin-bottom: 12px;
}
.action-section .el-button {
  margin: 0 8px;
}

@media (max-width: 768px) {
  .preview-inner {
    width: 72px;
    height: 90px;
  }
  .preview-inner .layer {
    width: 72px;
    height: 90px;
    background-size: 72px 90px;
  }
  .no-header {
    width: 72px;
    height: 90px;
    line-height: 90px;
    font-size: 11px;
  }
  .type-item {
    width: 40px;
    height: 50px;
  }
  .type-item img {
    width: 32px;
    height: 40px;
  }
}
</style>
